import { render, staticRenderFns } from "./Sample.vue?vue&type=template&id=035549c4&scoped=true"
import script from "./Sample.vue?vue&type=script&lang=js"
export * from "./Sample.vue?vue&type=script&lang=js"
import style0 from "./Sample.vue?vue&type=style&index=0&id=035549c4&prod&lang=css"
import style1 from "./Sample.vue?vue&type=style&index=1&id=035549c4&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035549c4",
  null
  
)

export default component.exports